import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights, formatIndianNumber } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";
import { GetDailyPerformanceSnapshotReport } from "../services/reports.services";

const DailyPerformanceSnapshotReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/dailyperformancesnapshotreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/dailyperformancesnapshotreportform",
    PRINT_ACCESS
  );

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const Destination = params?.Destination;
  const filterUser = params?.filterUser;

  const loading = useAppSelector((state) => state.reports.loading);
  const DailyPerformanceSnapshotListForReport = useAppSelector(
    (state) => state.reports.DailyPerformanceSnapshotListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        FromDate: filterFromDate !== "0" ? filterFromDate : "",
        ToDate: filterToDate !== "0" ? filterToDate : "",
        Destination: Destination !== "0" ? Destination : "",
        UserID: filterUser !== "0" ? filterUser : 0,
      };
      dispatch(GetDailyPerformanceSnapshotReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(
      wb,
      ws,
      "DailyPerformanceSnapshotReport"
    );

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "dailyperformancesnapshotreport.xlsx");
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Daily Performance Snapshot{" "}
          <span style={{ fontSize: 15 }}>
            {DailyPerformanceSnapshotListForReport &&
              DailyPerformanceSnapshotListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            DailyPerformanceSnapshotListForReport &&
            DailyPerformanceSnapshotListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            DailyPerformanceSnapshotListForReport &&
            DailyPerformanceSnapshotListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {DailyPerformanceSnapshotListForReport &&
      DailyPerformanceSnapshotListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  No
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Date
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  New Inquiries
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Quotation sent
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Bookings Confirmed
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-end"
                >
                  Total Revenue
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Follow-up Completed
                </th>
              </tr>
            </thead>
            <tbody>
              {DailyPerformanceSnapshotListForReport &&
                DailyPerformanceSnapshotListForReport.length > 0 &&
                DailyPerformanceSnapshotListForReport?.map(
                  (DailyPerformanceSnapshot: any, index: number) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">
                        {DailyPerformanceSnapshot?.Date
                          ? moment(
                              DailyPerformanceSnapshot?.Date,
                              "DD/MM/YYYY"
                            ).format("DD MMM YYYY")
                          : ""}
                      </td>
                      <td className="text-center">
                        {DailyPerformanceSnapshot?.NewInquiries || ""}
                      </td>
                      <td className="text-center">
                        {DailyPerformanceSnapshot?.QuotationSent || ""}
                      </td>
                      <td className="text-center">
                        {DailyPerformanceSnapshot?.BookingConfirmed || ""}
                      </td>
                      <td className="text-end">
                        {DailyPerformanceSnapshot?.TotalRevenue
                          ? formatIndianNumber(
                              DailyPerformanceSnapshot?.TotalRevenue || 0
                            )
                          : ""}
                      </td>
                      <td className="text-center">
                        {DailyPerformanceSnapshot?.FollowupsCompleted ||
                          ""}
                      </td>
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default DailyPerformanceSnapshotReportView;
